import { styled, alpha, Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

export const ItemToolbar = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.75),
  paddingLeft: theme.spacing(1),
  paddingTop: theme.spacing(1),
}));

export const removePillStyle: SxProps<Theme> = (theme) => ({
  color: theme.palette.error.main,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.error.main, 0.08),
  transition: theme.transitions.create(['background-color', 'border-color', 'color', 'box-shadow']),
  '&:hover': {
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main,
    backgroundColor: alpha(theme.palette.error.main, 0.16),
    boxShadow: `0 0 12px ${alpha(theme.palette.error.main, 0.3)}`,
  },
});
